//import Moment from "moment";

const getCount = (state) => {
	return state.unidadesMedida.length;
}

export default {
	getCount
}